<template>
    <div class="news">
        <Banner title="新闻资讯"/>
        <div class="news-section">
            <div class="news-section-content">
                <div class="content-nav">
                    <div
                        class="content-nav-btn"
                        :class="{'content-nav-active':newstype == 1}"
                        @click="newstype = 1"
                    >
                        <span>公司新闻</span>
                    </div>
                    <div
                        class="content-nav-btn"
                        :class="{'content-nav-active':newstype == 2}"
                        @click="newstype = 2"
                    >
                        <span>行业动态</span>
                    </div>
                </div>

                <div class="content-nav-item" v-if="newstype==1">
                    <div class="item-list" v-for="(news,index) in newsList" :key="index">
                        <div class="item-img">
                            <img :src="news.imgurl" alt="">
                        </div>
                        <p class="item-list-title">{{news.title}}</p>
                        <p class="item-list-content">{{news.Content}}</p>
                        <div class="item-list-more">
                            <router-link 
                                class=""
                                :to="{ name: 'newsdetails', params: { id: news.Id,news}}"
                            >
                                <img src="../assets/img/sanjiao.png" />
                                <span>more</span>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="content-nav-item" v-if="newstype==2">
                    <div class="item-list" v-for="(new2,index) in new2List" :key="index">
                        <div class="item-img">
                            <img :src="new2.imgurl" alt="">
                        </div>
                        <p class="item-list-title">{{new2.title}}</p>
                        <p class="item-list-content">{{new2.Content}}</p>
                        <div class="item-list-more">
                            <router-link 
                                :to="{ name: 'news2list', params: { id: new2.Id,new2}}"
                            >
                                <img src="../assets/img/sanjiao.png" />
                                <span>more</span>

                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Banner from '../components/Banner'
export default {
    data(){
        return{
            newstype: 1,
            newsList:[
                {
                    Id:1,
                    Type:1,
                    title:"不动产测绘的现状及问题分析",
                    CreateTime:"2019-11-30 15:42:38",
                    Content:`现状及问题分析:一是相关法规有待完善。目前，我国不动产测绘方面的法律主要包括《测绘法》 《房产测绘管理办法》等。伴随着不动产测绘工作的逐步深入，相关法律监管内容也有所改进，监管范围也有所扩大。但非常遗憾的是，不动产测绘的相关规定都较为粗线条，如《城市房地产管理法》《城市房地产开发经营管理条例》等的内容中，均只大致提到房产测绘工作，并未对房产测绘做出具体的要求。而其他类型的不动产测绘，面临的情况也大致相同。二是缺乏强有力的监管。目前，测绘机构入市门槛非常低，通常只需要10万元注册资金与3名技术人员便可申请入市。在此背景下，测绘机构多良莠不齐，大部分业务水平不高，不能满足市场需求。如：随着我国房产测绘行业的快速发展，房产测绘业务的规模与技术难度均明显提高，远超出了这些低资质房测机构的承受范围。由于技术落后、设备不足、人员技术水平不高等原因而导致测绘数据质量低劣。此外，在经济利益的驱使下，有房产测绘机构违背测绘规定或者打擦边球，以满足房地产开发企业的不合理要求。这直接扰乱了房地产市场的正常秩序，也使得购房人的合法权益受到损害。此外，现有的测绘成果异议处理机制中，由省级测管部门设立测绘成果质量监督检验机构，主要负责对测绘成果的监督检验，并具有委托检验与司法仲裁检验的职能。然而，在实践中因为很多主客观原因，该机构无法对不动产测绘成果进行有效的异议处理。三是测绘效率有待提高。目前，不动产测绘涉及多个部门，由于尚无统一标准，标准规范繁多，各部门在不动产测绘工作中往往各自为政，其所遵循的规范、标准及数据库规范方面均存在明显的不一致，最终造成房产、地籍等各类数据分离生产，相互不关联。比如，在土地数据中不能查到没有坐标的房产分层分户数据。同时，也不能将房产图形与档案相联系。这些情况的存在，造成不动产数据存在很大的安全隐患。所载内容来源互联网，微信公众号等公开渠道，转载的稿件版权归原作者和机构所有，如有侵权，请联系我们删除。`,
                    imgurl:require('../assets/img/new10.jpg')
                },
                {
                    Id:2,
                    Type:1,
                    title:"“不忘初心，我们砥砺前行”--2018-2019年度表彰总结大会",
                    CreateTime:"2019-2-20 11:23:15",
                    Content:`2019年1月18日是个好日子，期盼已久的佳渝测绘2018-2019年度表彰总结迎新年会在融汇创客会议中心拉开帷幕。本次年会以“不忘初心，继续前行”为主题，公司全体员工欢聚一堂，喜迎新春。在主持人激昂的开场词中，一切激动和喜悦在这里汇聚，年会由此揭开了它神秘的面纱。这是佳渝第一次正式的年度总结大会，这不仅仅是一种仪式感，更是佳渝人携手公司发展的决心和誓言。2018年佳渝公司完成了测绘资质的增项和升级、各类测绘、航测、研发方面技术人才的引进加入，在测绘高新技术方面也是成绩斐然，自主开发的园区土地管理系统，也得到了多个业主方的认可，这些成绩使佳渝在业界的声誉、地位都得到了大幅度的提升。2018对佳渝来说是不平凡的一年，是跨越式发展的一年。作为佳渝人，我们深有感触，我们心潮澎湃，我们斗志昂扬。`,
                    imgurl:require('../assets/img/new14.jpg'),
                    cimgurl:[
                        require('../assets/img/new14-1.jpg'),
                        require('../assets/img/new14-2.jpg'),
                    ],
                    c2imgurl:[
                        require('../assets/img/new14-3.jpg'),
                        require('../assets/img/new14-4.jpg'),
                    ],
                    c3imgurl:require('../assets/img/new14-5.jpg'),
                    m1:`2018年公司涌现大批优秀人才，创先争优是形式，表彰激励是手段，带动前行是目的。佳渝的今天，有公司领导的英明决策，也离不开全体员工的共同努力。更是优秀员工以实际行动来带动着全体佳渝人携手前行，榜样的力量是无穷的。这是一场既团结紧张又严肃活泼的表彰总结大会，既有对榜样的表彰，也有对青年新进员工的鼓励，更有新颖的抽奖环节，会场的气氛异场活跃。超高的中奖率，引得全场尖叫不断，参加活动的小伙伴们收获多多。`,
                    m2:`2018年，是机遇与挑战并行的一年，佳渝公司在董事长曾亮先生的带领下，加快主业发展，突出高新技术项目经营，加强内部体系管理建设，2018年公司经营总值再创新高，在此公司董事长曾亮先生对2019的战略规划发表了重要讲话。`,
                    m3:`董事长回顾了佳渝测绘一路走来的艰辛，展望了2019的具体发展，佳渝公司在开拓中进取，在进取中成长。2019我们整装待发，全体员工不忘初心，砥砺前行。续写佳渝美好的未来。`
                },
                {
                    Id:3,
                    Type:1,
                    title:"影响无人机成果精度三大要素",
                    CreateTime:"2018-10-19 13:39:59",
                    Content:`一、无人机航空摄影测量概述:低空数字航空摄影测量相对传统摄影测量来说，机动快速，操作简单，云下摄影，能获取高分辨率航空影像，影像制作周期短，效率高，成本低，在应急测绘、困难地区测绘、小城镇测绘、重大工程项目测绘、小范围高精度测绘应用广泛。 
                            但是，固定翼无人机舰空摄影侧量系统采用的传感器是由工业级CCD 改装的相机。这种相机为非测量相机，较之传统的测绘航空摄影传惑器，存在着光学畸变差CCD阵面非正交性所产生的误差。另外，由于CCD阵面为非正方形，其摄影机的放置方式也影响实际航空摄影的基线长度。再加上后期像控点联测，立体量测的误差，形成了影像无人机航空摄影测量最终产品质量的主要因素。
                            二、影响无人机航测精度的几大要素:固定翼无人机航空测量系统在进行地形测量时，存在着测量误差。这些误差主要来源于仪器误差、人为误差、气候等外界因素影响产生的误差。a、仪器误差:由于仪器设计、制作不完善，或经校验还存在残余误差。这部分误差主要是传感器量化过程带来的系统误差。由于固定翼无人机的载重及体积的原因，无法搭载常规的航摄仪进行测绘航空摄影，自前选用的是中幅面CCD作为传感器的感光单元，经过加固和电路改装以后，成为具有稳定内方价元索豹数码相机。由于感光单元的非正方形因子和非正交性以及畸变差的存在，畸变差的存在使测量成果无法满足精度要求。
                            小型数码相机一般均为矩形阵面的CCD，并非传统的正方形。像片重叠度越大基线越短，基高比越小，正常情况下，其基高比为0.15左右，远小于传统摄影的0.50，在立体模型下，同名地物交会角较小，降低了立体观测效果，直接影响高程量测精度。如果在保证具有三度重叠的前提下，尽量减少相片重叠度或使CCD阵面的长边与摄影航线相一致，可以大大增加基高比，提高高程量测精度
                            b、人为误差:由于人的感官鉴别能力、技术水平和工作态度因素带来的误差，以及像控识别、空三加密、立体采集产生的人为误差。像控点精度有刺点精度和观测精度。在观测精度符合设计要求的情况下，刺点精度成为影响像片控制测量精度的主要因素。由于固定翼无人机的像幅较小，可供选择像控点位的范围相对较小，经常会出现在像控点布设的范围内找不到明显地物刺点，尤其是在野外居民地稀少地区，像控点选刺在地物棱角是否明显，影像反差是否理想的地点，都是制约像控点精度的因素。 
                            外业像控点测量时，对目标点的选取主要取决于影像纹理的丰富程度，影像纹理粗糙、弧形地物、线状地物交角不好，直接影响了外业点位选取精度，同时内业对像控点的转刺同样有较大的误差，较低了成图精度。如果采取先布设地面目标点后摄影，则能较大提高外业选点精度和内业转刺点精度，有助于提高成图质量。 内业数据采集分为空三加密与立体量测。像控点识别与判读均会与外业实际位置产生一定的误差，空三加密时也会有一定的误差，还有在立体采集量测时切测的误差等等。c、外界因素:由于天气状况对飞行器姿态和成像质量的影响产生的误差。对摄影成像来说，景物亮度的大小只影响像片上的曝光量，重要的是像片上相邻地物影像之间的密度差，如果地物影像之间没有密度差异，也就是没有影像反差，也就无法从影像上辨别地物，而决定影像反差的因素除了景物本身特征外，主要取决于阳光部分和阴影部分照度之间的差异，如果选择天气条件不好时摄影，必然使影像质量变差。 
                            微型无人机体积较小，一般都在三十公斤之内，在摄影时受气流、风力、风向影响较大，无法保持直线平稳飞行，航线倾角、旁向倾角和旋转角都很大，飞行姿态难以控制，飞机在航线前后左右等方向上摆动造成了影像模糊，影像了清晰度。另外，由于遥控无人机采用低空飞行，航高较低，相对地面物体移动速度较快，在曝光过程中，成像面上的地物构像随之产生位移，形成像移，像移的出现同样使影像模糊，影响了成像质量。`,
                    imgurl:require('../assets/img/new11.jpg')
                },
                {
                    Id:4,
                    Type:1,
                    title:"测绘无人机航测操步骤介绍",
                    CreateTime:"2019-11-30 15:42:38",
                    Content:`1、判断天气条件:无人机航测，气象条件的好坏是前提。出发航拍之前，要掌握当日天气情况，并观察云层厚度、光照和空气能见度。 观察云层厚度,2、到达起飞地点:确定天气状况、云层分布情况适合航拍后，带上无人机、弹射架、电台、电脑等相关设备赶赴航拍起飞点。起飞点通常事先进行考察，要求现场比较平坦，无电线，高层建筑等，并提前确定好航拍架次及顺序。  
                            3、测定现场风速:到达现场后，测定风速。4、架设弹射架:为保证飞机起飞平稳，弹射架一般逆风架设。5、架设电台 电台用于地面站和无人机之间的通讯。6、当天作业日志 记录当天风速、天气、起降坐标等信息，留备日后数据参考和分析总结。
                            7、姿态角度调整:对于距离上一次起飞地点超过200km的起飞地点，需对飞机姿态、角度进行调整，以确保飞机准确通讯。8、无人机放至弹射架:安装时需检查无人机各部件是否连接紧密，弹射架供电接线是否正确连接，电力充足。9、手动遥控测试 将飞行模式调至手动遥控飞行状态，测试机头、机身、尾翼是否能按指令操作。手动遥控模式主要用于无人机起飞和降落时遇特殊情况时的应急处理。
                            10、起飞前准备:起飞前要检查进行航拍相机与飞控系统是否连接，降落伞包处于待命状态，与风向平行、无人员车辆走动等。
                            11、无人机起飞:各项准备工作完毕后，就可以起飞了。这时，操作手应持手动操作杆待命，观察现场状况，根据需要随时手动调整飞机姿态及飞行高度。 发布命令，起飞
                            12、飞行监测这个过程主要做三个工作： ①对航高、航速、飞行轨迹的监测； ②对发动机转速和空速、地速进行监控； ③随时检查照片拍摄数量。
                            13、无人机降落无人机按设定路线飞行航拍完毕后，降落在指定地点。手动遥控操作手到指定地点待命，在降落现场突发大风、人员走动等情况时及时调整降落地点。
                            14、数据导出检查:降落后，对照片数据及飞机整体进行检查评估，结合贴线率和姿态角判断是否复飞，继续完成附近区域的航拍任务或转场，理论上一个起降点的飞行控制范围为300平方公里。拷贝飞行数据 无人机航拍图 在全国范围内，无人机遥感技术多次应用于农村土地确权工作，技术已经成熟，不仅成果精度远优于传统测量方式，而且工作耗时大大缩短，减轻了农村基层管理人员的工作量，节约了人力物力，在农村土地确权工作中值得推广。测绘无人机正以其高机动性，高性价比以及高安全性服务于经济社会发展的各个环节。`,
                    imgurl:require('../assets/img/new12.jpg')
                },
                {
                    Id:5,
                    Type:1,
                    title:"有哪些技术会影响无人机的精准导航定位",
                    CreateTime:"2019-11-30 15:42:38",
                    Content:`英特尔、高通、英伟达等多平台召开无人机发布会宣布进军消费级无人机市场，此举使得消费级的航拍无人机炙手可热。与此同时，用于检测地球磁场的MEMS磁传感器也广泛应用到航拍无人机导航系统，以提升导航定位的精度及速度。
                            航拍无人机根据具体应用可将其划分为专业以及消费级别。消费级无人机航拍系统常采用来自手机等消费类产品的磁传感器，而专业级无人机由于对航拍稳定性以及航拍质量的严格要求，因此常使用工业级的MEMS磁传感器以保障导航定位的精确性。
                            目前航拍无人的导航方式综合采用了GPS+惯性导航的方式。惯性导航通常是由两个或以上的传感器(陀螺仪、加速度计、磁场计和/或GPS)信息用于飞机相对地球的航向矢量和速度矢量。
                            加速度计用于测量加速度。借助一个三轴加速度计可以测得一个固定平台相对地球表面的运动方向，但是一旦平台运动起来，情况就会变得复杂的多。如果平台做自由落体，加速度计测得的加速度值为零。如果平台朝某个方向做加速度运动，各个轴向加速度值会含有重力产生的加速度值，使得无法获得真正的加速度值。例如，安装在60度横滚角飞机上的三轴加速度计会测得2G的垂直加速度值，而事实上飞机相对地区表面是60度的倾角。因此，单独使用加速度计无法使飞机保持一个固定的航向。
                            陀螺仪测量机体围绕某个轴向的旋转角速率值。使用陀螺仪测量飞机机体轴向的旋转角速率时，如果飞机在旋转，测得的值为非零值，飞机不旋转时，测量的值为零。因此，在60度横滚角的飞机上的陀螺仪测得的横滚角速率值为零，同样在飞机做水平直线飞行时，角速率值为零。可以通过角速率值的时间积分来估计当前的横滚角度，前提是没有误差的累积。陀螺仪测量的值会随时间漂移，经过几分钟甚至几秒钟定会累积出额外的误差来，而最终会导致对飞机当前相对水平面横滚角度完全错误的认知。因此，单独使用陀螺仪也无法保持飞机的特定航向。
                            由此可以看出加速度计在较长时间的测量值(确定飞机航向)是正确的，而在较短时间内由于信号噪声的存在，则会出现误差。陀螺仪在较短时间内则比较准确而较长时间则会有与漂移而存有误差。因此，需要两者(相互调整)来确保航向的正确。
                            事实上，即使使用了两者，也只可以用于测得飞机的俯仰和横滚角度。对于偏航角度，由于偏航角和重力方向正交，无法用加速度计测量得到，而由于MEMS磁传感器对磁场变化和惯性力十分敏感，因此常用作校准测量偏航角度的陀螺仪的漂移值。`,
                    imgurl:require('../assets/img/new13.jpg')
                },
                {
                    Id:6,
                    Type:1,
                    title:"倾斜摄影测量技术应用及展望",
                    CreateTime:"2018-10-19 13:37:42",
                    Content:`倾斜摄影测量技术是近年来发展起来的一项新的测量技术。它改变了以往航测遥感影像只能从垂直方向拍摄的局限性，倾斜摄影测量技术通过多台传感器从不同的角度进行数据的采集，快速、高效获取丰富的数据信息，真实地反映地面的客观情况，满足人们对三维信息的需求。目前，倾斜摄影测量技术已经应用于实际的生产实践。
                            本文针对倾斜摄影测量的发展及应用现状、特点、影像的匹配以及摄影测量技术的优势等问题进行了详细的描述，并对数据的处理过程以及存在的问题进行总结。倾斜摄影测量技术作为新兴的高科技成果，它的出现满足了人们的需求，具有广泛应用前景。
                            1、倾斜摄影测量概述,1.1倾斜摄影测量技术:通过在同一飞行平台上搭载5台传感器，同时从一个垂直、四个倾斜五个不同的角度采集影像，拍摄相片时，同时记录航高，航速，航向和旁向重叠，坐标等参数，然后对倾斜影像进行分析和整理。在一个时段，飞机连续拍摄几组影像重叠的照片，同一地物最多能够在3张相片上被找到，这样内业人员可以比较轻松地进行建筑物结构分析，并且能选择最为清晰的一张照片进行纹理制作。向用户提供真实直观的实景信息。影像数据不仅能够真实地反映地物情况，而且可通过先进的定位技术，嵌入地理信息、影像信息，获得更高的用户体验，极大地拓展遥感影像的应用范围。
                            1.2倾斜摄影技术特点,1.2.1反映地物真实情况并且能对地物进行量测:倾斜摄影测量所获得三维数据可真实地反映地物的外观、位置、高度等属性，增强了三维数据所带来的真实感，弥补了传统人工模型仿真度低的缺点。增强了倾斜摄影技术的应用。
                            1.2.2高性价比:倾斜摄影测量数据是带有空间位置信息的可量测的影像数据，能同时输出DSM、DOM、DLG等数据成果。可在满足传统航空摄影测量的同时获得更多的数据。同时使用倾斜影像批量提取及贴纹理的方式，能够有效地降低城市三维建模成本。
                            1.2.3高效率:倾斜摄影测量技术借助无人机等飞行载体可以快速采集影像数据，实现全自动化的三维建模。实验数据证明：1～2年的中小城市人工建模工作，借助倾斜摄影测量技术只需3～5个月就可完成。
                            1.3倾斜摄影测量的关键技术:1.3.1多视影像联合平差:多视影像不仅包含垂直摄影数据，还包括倾斜摄影数据，而部分传统空中三角测量系统无法较好地处理倾斜摄影数据，因此，多视影像联合平差需充分考虑影像间的几何变形和遮挡关系。结合POS系统提供的多视影像外方位元素，采取由粗到精的金字塔匹配策略，在每级影像上进行同名点自动匹配和自由网光束法平差，得到较好的同名点匹配结果。同时，建立连接点和连接线、控制点坐标、GPU/IMU辅助数据的多视影像自检校区域网平差的误差方程，通过联合解算，确保平差结果的精度。
                            1.3.2多视影像密集匹配:影像匹配是摄影测量的基本问题之一，多视影像具有覆盖范围大，分辨率高等特点。因此，如何在匹配过程中充分考虑冗余信息，快速准确地获取多视影像上的同名点坐标，进而获取地物的三维信息，是多视影像匹配的关键。由于单独使用一种匹配基元或匹配策略往往难以获取建模需要的同名点，因此，近年来随着计算机视觉发展起来的多基元、多视影像匹配，逐渐成为人们研究的焦点。目前，在该领域的研究已取得了很大进展，例如建筑物侧面的自动识别与提取。通过搜索多视影像上的特征，如建筑物边缘、墙面边缘和纹理，来确定建筑物的二维矢量数据集，影像上不同视角的二维特征可以转化为三维特征，在确定墙面时，可以设置若干影响因子并给予一定的权值，将墙面分为不同的类，将建筑的各个墙面进行平面扫描和分割，获取建筑物的侧面结构，再通过对侧面进行重构，提取出建筑物屋顶的高度和轮廓。
                            1.3.3数字表面模型生成和真正射影像纠正:多视影像密集匹配能得到高精度高分辨率的数字表面模型DSM，充分地表达了地形地物起伏特征，已经成为新一代空间数据基础设施的重要内容。由于多角度倾斜影像之间的尺度差异较大，加上较严重的遮挡和阴影等问题，基于倾斜影像的自动获取DSM存在新的难点。可以首先根据自动空三解算出来的各影像外方位元素，分析与选择合适的影像匹配单元进行特征匹配和逐像素级的密集匹配，引入并行算法，提高计算效率。在获取高密度DSM数据后，进行滤波处理，将不同匹配单元进行融合，形成统一的DSM。多视影像真正射纠正涉及物方连续的数字高程模型DEM和大量离散分布粒度差异很大的地物对象，以及海量的像方多角度影像，具有典型的数据密集和计算密集特点。在有DSM的基础上，根据物方连续地形和离散地物对象的几何特征，通过轮廓提取、面片拟合、屋顶重建等方法提取物方语义信息;同时在多视影像上，通过影像分割、边缘提取、纹理聚类等方法获取像方语义信息，再根据联合平差和密集匹配的结果建立物方和像方的同名点对应关系，继而建立全局优化采样策略和顾及几何辐射特性的联合纠正，同时进行整体匀光处理，如图1所示，倾斜摄影测量数据处理流程。
                            1.4倾斜摄影技术的应用:由于倾斜影像为用户提供了更丰富的地理信息，更友好的用户体验，该技术目前在欧美等发达国家已经广泛应用于应急指挥、国土安全、城市管理、房产税收等行业。在国内政府部门用于：国土资源管理、房产税收、人口统计、数字城市、城市管理、应急指挥、灾害评估、环保监测。企事业单位：房地产、工程建筑、实景导航、旅游规划等领域。
                            2、无人机倾斜摄影测量概况:无人机具有机动、灵活、快速、经济等特点，以无人机作为航空摄影平台能够快速高效地获取高质量、高分辨率的影像，无人机在摄影测量中的优势是传统卫星遥感无法比拟的，越来越受到研究者和生产者的青睐，大大地扩大了遥感的应用范围和用户群，具有广阔的应用前景。无人机倾斜摄影测量已经成为未来航空摄影测量的重要手段和国家航空遥感监测体系的重要补充，逐步从研究开发阶段发展到了实际应用阶段。
                            在国外，美国航空航天局将无人机应用于森林火灾监测、精确农业、海洋遥感等研究项目。澳大利亚利用全球鹰搭载成像SAR进行海洋监测研究。在国内，红鹏公司微型无人机倾斜摄影系统将无人机技术与倾斜摄影技术有效地结合，自主研发完成了一套微型无人机倾斜摄影系统，包括电动六旋翼无人机、五相机倾斜摄影吊舱、降落伞模块、控制模块等。系统具有成本低、飞行可靠性高、操作使用简单、起飞和着陆场地要求低。定位精度与影像分辨率高等特点，可以满足倾斜摄影测量与快速三维建模对数据获取的要求。目前国内外尚无类似微型倾斜摄影产品平台，弥补了微型超低空低成本获取倾斜摄影测量高分辨率数据的空白，可为测绘、规划、应急、公安、旅游文化等行业提供低廉、高效、敏捷的数据支持与服务，提高了精细三维数据灵活快速获取的能力。应用成果已在公安、应急、测绘、旅游、环保等行业得到了应用验证，获得了用户的好评。社会经济效益显著，具有重要的示范作用和推广价值。
                            3、倾斜摄影测量技术存在的问题:1)倾斜航空摄影后期数据影像匹配时，因倾斜影像的摄影比例尺不一致、分辨率差异、地物遮挡等因素导致获取的数据中含有较多的粗差，严重影响后续影像空三精度。然而，如何利用倾斜摄影测量中包含了大量的冗余信息进行数据的高精度匹配是提高倾斜摄影技术实用性的关键。
                            2)倾斜摄影测量所形成的三维模型在表达整体的同时，某些地方存在模型缺失或失真等问题。因此，为了三维模型的完整准确地表达需要进行局部区域的补测，常用方法是人工相机拍照或者使用车载近景摄影测量系统进行补测。
                            3)随着科技的发展无人机作为倾斜摄影测量实用的载体，为了增加其便携性和灵活性，无人机的续航能力不强，因此，电池的续航能力成为其推广的限制条件，研制体积小长续航的电池迫在眉睫。
                            4、展望:近几年，倾斜摄影测量技术得到了迅速的发展，由于倾斜摄影测量技术能够获取建筑物、树木等地理实体的纹理细节不但丰富了影像数据源信息。同时，高冗余度的航摄影像重叠，为高精度的影像匹配提供了条件，使得基于人工智能的三维实体重建成为了可能。分层显示技术、纹理映射技术成为倾斜摄影测量和建模的关键支撑点，极大地提升了三维建模的效率，同时也降低建模的生产成本。目前，基于倾斜摄影测量成果的应用还比较少，因此，大量的应用创新点挖掘还需要逐步深入。同时我们不能局限于倾斜摄影测量技术，还需要研究其与雷达、红外、多光谱、高光谱等多种的传感器的结合，将他们集成在更小的无人机上拓宽摄影测量技术的应用范围，未来基于点云数据计算的大规模三维数据生产使得工程测量、三维建模等工作进行颠覆性的变革，开启三维遥感的新时代。`,
                    imgurl:require('../assets/img/new15.jpg')
                },
                {
                    Id:7,
                    Type:1,
                    title:"航空摄影的分类和操作实施",
                    CreateTime:"2019-9-28 15:59:12",
                    Content:` 航空摄影又称“空中摄影”。是指利用航空器上安置专用航空摄影仪，从空中对地面或空中目标所进行的摄影方式。按摄影目标和方向的不同，可划分为垂直摄影、倾斜摄影和对空摄影。能减少野外作业量，减轻劳动强度，并且不受地理环境条件的限制，具有快速、精确、经济等优点。广泛用于测绘地图、地质、水文、矿藏和森林资源调査、农业产量评估及大型厂矿和城镇的规划、铁路、公路、高压输电线路和输油管线的勘察选线、气象预报和环境监测等,也可用于航空侦察、新闻报道和拍摄电影、电视片。
                                航空摄影一般选在上午或下午，因为上午或下午地面上的景物比较清晰，有足够的照度，容易收到较好的影调效果。 航空摄影始于19世纪50年代，纳达尔是首位实现航拍的摄影师和气球驾驶者，他于1858年在法国巴黎上空拍摄。当时从气球上用摄影机拍摄的城市照片，虽只有观赏价值，却开创了从空中观察地球的历史。1909年美国的莱特(W.Wright)第一次从飞机上对地面拍摄像片。此后，随着飞机和飞行技术，以及摄影机和感光材料等的飞速发展,航空摄影像片的质量有了很大提高,用途日益广泛。它不仅大量用于地图测绘方面，而且在国民经济建设、军事和科学研究等许多领域中得到广泛应用。
                                基本分类:根据用途的不同，航空摄影可选用不同的方式和感光材料，从而得到功能不同的航空像片。按像片倾斜角分类,按像片倾斜角分类（像片倾斜角是航空摄影机主光轴与通过透镜中心的地面铅垂线（主垂线）间的夹角），可分为垂直摄影和倾斜摄影。
                                倾斜角等于0°的，是垂直摄影，这时主光轴垂直于地面（与主垂线重合），感光胶片与地面平行。但由于飞行中的各种原因，倾斜角不可能绝对等于0°，一般凡倾斜角小于3°的称垂直摄影。由垂直摄影获得的像片称为水平像片。水平像片上地物的影像，一般与地面物体顶部的形状基本相似，像片各部分的比例尺大致相同。水平像片能够用来判断各目标的位置关系和量测距离。倾斜角大于3°的，称为倾斜摄影，所获得的像片称为倾斜像片。这种像片可单独使用，也可以与水平像片配合使用。
                                按摄影的实施方式分类:按摄影的实施方式分类，可分为单片摄影、航线摄影和面积摄影。单片摄影：为拍摄单独固定目标而进行的摄影称为单片摄影，一般只摄取一张（或一对）像片。航线摄影：沿一条航线，对地面狭长地区或沿线状地物（铁路、公路等）进行的连续摄影，称为航线摄影。为了使相邻像片的地物能互相衔接以及满足立体观察的需要，相邻像片间需要有一定的重叠，称为航向重叠。航向重叠一般应达到60%，至少不小于53%。
                                面积摄影：沿数条航线对较大区域进行连续摄影，称为面积摄影（或区域摄影）。面积摄影要求各航线互相平行。在同一条航线上相邻像片间的航向重叠为60—53%。相邻航线间的像片也要有一定的重叠，这种重叠称为旁向重叠，一般应为30—15%。实施面积摄影时，通常要求航线与纬线平行，即按东西方向飞行。但有时也按照设计航线飞行。由于在飞行中难免出现一定的偏差，故需要限制航线长度。一般为60—120km，以保证不偏航，而产生漏摄。
                                按感光材料分类:可分为全色黑白摄影、黑白红外摄影、彩色摄影、彩色红外摄影和多光谱摄影等。全色黑白摄影：采用全色黑白感光材料进行的摄影。它对可见光波段（0.4—0.76μm）内的各种色光都能感光，是一种应用范围广，容易收集到的航空遥感材料。如我国为测制国家基本地形图摄制的航空像片即属此类。
                                黑白红外摄影：采用黑白红外感光材料进行的摄影。它能对可见光、近红外光（0.4—1.3μm）波段感光，尤其对水体植被反应灵敏，所摄像片具有较高的反差和分辨率。
                                彩色摄影：彩色像片虽然也是感受可见光波段内的各种色光，但由于它能将物体的自然色彩、明暗度以及深浅表现出来，因此与全色黑白像片相比，影像更为清晰，分辨能力高。
                                彩色红外摄影：彩色红外摄影虽然也是感受可见光和近红外波段（0.4—1.3μm），但却使绿光感光之后变为蓝色，红光感光之后变为绿色，近红外感光后成为红色，这种彩色红外片与彩色片相比，在色别、明暗度和饱合度上都有很大的不同。例如在彩色片上绿色植物呈绿色，在彩色红外片上却呈红色。由于红外线的波长比可见光的波长长，受大气分子的散射影响小，穿透力强，因此，其彩色红外片色彩要鲜艳得多。
                                多光谱摄影：多光谱摄影是利用摄影镜头与滤光片的组合，同时对一地区进行不同波段的摄影，取得不同的分波段像片。例如通常采用的四波段摄影，可同时得到蓝、绿、红及近红外波段四张不同的黑白像片，或合成为彩色像片；或将绿、红、近红外三个波段的黑白像片，合成假彩色像片。`,
                    imgurl:require('../assets/img/new16.jpg')
                },
                {
                    Id:8,
                    Type:1,
                    title:"航空摄影的分类和操作实施",
                    CreateTime:"2019-9-28 15:59:12",
                    Content:` 航空摄影又称“空中摄影”。是指利用航空器上安置专用航空摄影仪，从空中对地面或空中目标所进行的摄影方式。按摄影目标和方向的不同，可划分为垂直摄影、倾斜摄影和对空摄影。能减少野外作业量，减轻劳动强度，并且不受地理环境条件的限制，具有快速、精确、经济等优点。广泛用于测绘地图、地质、水文、矿藏和森林资源调査、农业产量评估及大型厂矿和城镇的规划、铁路、公路、高压输电线路和输油管线的勘察选线、气象预报和环境监测等,也可用于航空侦察、新闻报道和拍摄电影、电视片。
                                航空摄影一般选在上午或下午，因为上午或下午地面上的景物比较清晰，有足够的照度，容易收到较好的影调效果。 航空摄影始于19世纪50年代，纳达尔是首位实现航拍的摄影师和气球驾驶者，他于1858年在法国巴黎上空拍摄。当时从气球上用摄影机拍摄的城市照片，虽只有观赏价值，却开创了从空中观察地球的历史。1909年美国的莱特(W.Wright)第一次从飞机上对地面拍摄像片。此后，随着飞机和飞行技术，以及摄影机和感光材料等的飞速发展,航空摄影像片的质量有了很大提高,用途日益广泛。它不仅大量用于地图测绘方面，而且在国民经济建设、军事和科学研究等许多领域中得到广泛应用。
                                基本分类:根据用途的不同，航空摄影可选用不同的方式和感光材料，从而得到功能不同的航空像片。按像片倾斜角分类,按像片倾斜角分类（像片倾斜角是航空摄影机主光轴与通过透镜中心的地面铅垂线（主垂线）间的夹角），可分为垂直摄影和倾斜摄影。
                                倾斜角等于0°的，是垂直摄影，这时主光轴垂直于地面（与主垂线重合），感光胶片与地面平行。但由于飞行中的各种原因，倾斜角不可能绝对等于0°，一般凡倾斜角小于3°的称垂直摄影。由垂直摄影获得的像片称为水平像片。水平像片上地物的影像，一般与地面物体顶部的形状基本相似，像片各部分的比例尺大致相同。水平像片能够用来判断各目标的位置关系和量测距离。倾斜角大于3°的，称为倾斜摄影，所获得的像片称为倾斜像片。这种像片可单独使用，也可以与水平像片配合使用。
                                按摄影的实施方式分类:按摄影的实施方式分类，可分为单片摄影、航线摄影和面积摄影。单片摄影：为拍摄单独固定目标而进行的摄影称为单片摄影，一般只摄取一张（或一对）像片。航线摄影：沿一条航线，对地面狭长地区或沿线状地物（铁路、公路等）进行的连续摄影，称为航线摄影。为了使相邻像片的地物能互相衔接以及满足立体观察的需要，相邻像片间需要有一定的重叠，称为航向重叠。航向重叠一般应达到60%，至少不小于53%。
                                面积摄影：沿数条航线对较大区域进行连续摄影，称为面积摄影（或区域摄影）。面积摄影要求各航线互相平行。在同一条航线上相邻像片间的航向重叠为60—53%。相邻航线间的像片也要有一定的重叠，这种重叠称为旁向重叠，一般应为30—15%。实施面积摄影时，通常要求航线与纬线平行，即按东西方向飞行。但有时也按照设计航线飞行。由于在飞行中难免出现一定的偏差，故需要限制航线长度。一般为60—120km，以保证不偏航，而产生漏摄。
                                按感光材料分类:可分为全色黑白摄影、黑白红外摄影、彩色摄影、彩色红外摄影和多光谱摄影等。全色黑白摄影：采用全色黑白感光材料进行的摄影。它对可见光波段（0.4—0.76μm）内的各种色光都能感光，是一种应用范围广，容易收集到的航空遥感材料。如我国为测制国家基本地形图摄制的航空像片即属此类。
                                黑白红外摄影：采用黑白红外感光材料进行的摄影。它能对可见光、近红外光（0.4—1.3μm）波段感光，尤其对水体植被反应灵敏，所摄像片具有较高的反差和分辨率。
                                彩色摄影：彩色像片虽然也是感受可见光波段内的各种色光，但由于它能将物体的自然色彩、明暗度以及深浅表现出来，因此与全色黑白像片相比，影像更为清晰，分辨能力高。
                                彩色红外摄影：彩色红外摄影虽然也是感受可见光和近红外波段（0.4—1.3μm），但却使绿光感光之后变为蓝色，红光感光之后变为绿色，近红外感光后成为红色，这种彩色红外片与彩色片相比，在色别、明暗度和饱合度上都有很大的不同。例如在彩色片上绿色植物呈绿色，在彩色红外片上却呈红色。由于红外线的波长比可见光的波长长，受大气分子的散射影响小，穿透力强，因此，其彩色红外片色彩要鲜艳得多。
                                多光谱摄影：多光谱摄影是利用摄影镜头与滤光片的组合，同时对一地区进行不同波段的摄影，取得不同的分波段像片。例如通常采用的四波段摄影，可同时得到蓝、绿、红及近红外波段四张不同的黑白像片，或合成为彩色像片；或将绿、红、近红外三个波段的黑白像片，合成假彩色像片。`,
                    imgurl:require('../assets/img/new18.jpg')
                },
            ],
            new2List:[
                
                {
                    Id:10,
                    Type:2,
                    title:"优化国土空间布局 推进生态文明建设",
                    CreateTime:"2019/11/13 16:35",
                    Content:`11月11日至12日，2019年中国土地学会学术年会在福建省福州市举行。本次年会以“国土空间布局与生态文明建设”为主题，紧紧围绕党中央、国务院提出的建立国土空间规划体系的目标和要求，紧扣国土空间布局中的热点难点问题，深入研讨，广泛交流。 会议认为，建设生态文明是中华民族永续发展的千年大计。大会以“国土空间布局与生态文明建设”为主题，是落实生态文明建设的必然要求，是自然资源系统推进多规合一、构建新的国土空间规划格局的现实需要，是推进国家空间治理体系和治理能力现代化的重要内容。
                                会议提出，当前国土空间规划体系改革的目标、方向、路径已经明确， 但如何在960多万平方公里的美丽国土上，具体谋划十几亿人口、近百万亿经济总量在国土空间的布局，是当前摆在自然资源工作者面前的重大课题，需要充分把握好国土空间布局与生态文明建设的内在关系。一方面，要认识到优化国土空间布局是生态文明建设的载体，是践行习近平生态文明思想的空间蓝图。另一方面，要充分认识到生态文明是优化国土空间布局的目的，是检验国土空间布局是否科学合理的标准。这就需要在具体的优化国土空间布局研究和规划体系建设中，必须综合考虑人口分布、经济布局、国土利用、生态环境保护等因素，科学布局生产空间、生活空间、生态空间，把国土空间承载的各项任务落到实处。
                                “土地学会和广大的土地科技工作者是生态文明建设、优化国土空间布局即规划体系建设的重要力量，是国家空间治理体系和治理能力现代化的重要推动者。”中国土地学会理事长王世元在开幕式致辞时表示，希望广大土地科技工作者，一要始终坚持以习近平新时代中国特色社会主义思想特别是习近平生态文明思想为统领，继续在学懂、弄通、做实上下功夫，紧紧围绕生态文明建设和国土空间规划体系改革的方向、目标、任务和路径，凝心聚力做好研究和支撑工作。二要坚持探索创新，深入研究建立国土空间规划体系并监督实施的重大问题，支撑国土空间规划编制审批体系、实施监督体系、法规政策体系、技术标准体系，推动中国特色国土空间规划体系理论实践的不断探索创新。三要践行绿色发展理念，持续跟踪国土空间规划体系建设的创新实践，不断总结各地破解难题的实践经验，及时提炼上升为政策和制度建议，为国土空间治理体系和治理能力现代化作出更大贡献。本次年会由中国土地学会主办，福建省土地学会承办，福建省自然资源厅、中国国土勘测规划院、自然资源部土地利用重点实验室、福建农林大学、福州市自然资源和规划局协办。6位业内专家受邀作大会学术报告。会议为10位“2019年中国土地学会学术年会青年优秀论文”获奖者代表颁奖，并设立了16个分会场，分别围绕大会主题进行学术交流。会场上，20多家卫星遥感、信息化支撑企业单位用展板方式进行成果展示。`,
                    imgurl:require('../assets/img/new2.jpg')
                },
                {
                    Id:11,
                    Type:2,
                    title:"自然资源部废止和修改这些规章！",
                    CreateTime:"2020/04/07 15:43",
                    Content:`中华人民共和国自然资源部令第6号 《自然资源部关于第二批废止和修改的部门规章的决定》已经2020年自然资源部第1次部务会议审议通过，现予公布，自公布之日起施行。   部长 陆 昊2020年3月20日   自然资源部关于第二批废止和修改的部门规章的决定（2020年自然资源部第1次部务会议通过）一、废止以下规章 《征收土地公告办法》（国土资源部令第49号）《测绘行政处罚程序规定》（国土资源部`,
                    imgurl:require('../assets/img/new3.jpg')
                },
                {
                    Id:12,
                    Type:2,
                    title:"【探讨】查清国土资源家底，服务经济社会发展",
                    CreateTime:"2019/11/12 16:38",
                    Content:`我国土地资源类型很多，除耕地外还有林地、草地、水体、园地、未利用地、道路、沙地、滩涂等。查清国土资源家底，既是保证国民经济发展规划科学性的现实需要，也是合理开发、高效利用自然资源的实际需求，可以为按照科学规律、自然规律、经济规律、社会规律进行决策提供客观依据。 为此，改革开放之后 我国先后开展了三次全国范围的土地资源调查 目前正在开展的第三次全国国土调查已 全面进入国家级核查阶段`,
                    imgurl:require('../assets/img/new4.jpg')
                },
                {
                    Id:13,
                    Type:2,
                    title:"无人机航测时如何正确布设像控点",
                    CreateTime:"2018/10/19 13:42",
                    Content:`对无人机操作和演示的要求也越来越高。其间布设像控点是要害的一环。这也直接决定着无人机航测成果的展现，一般都有专业的无人机公司会有专门的技术，那么如何正确布设像控点呢？
                            一、根据航测区域确定像控点数量
                            像控点的精度和数量直接影响到航测数据后处理的精度，所以像控点的布设和选择应当尽量规范、严格、精确。
                            通常情况下，不同翼型的无人机，像控点的布设数量也有所区别。
                            以复合翼无人机为例，假设飞1:1000的比例尺成果，3个平方公里的区域布设5个像控点合适，7-8个平方公里10个像控点合适。
                            以六旋翼无人机P560H为例，飞1:1000比例尺的成果，0.3个平方公里布设5个像控点合适。
                            二、野外布设像控点
                            布设像控点之前要做好准备工作，首先要检查航测区域的地质地貌条件，准备好油性喷漆、标靶板（木板或者做的硬纸板）。
                            像控点应选在印象明晰的地物点上，当刺点方针与方位不能统筹时，以方针为主。
                            三、像控点测量
                            像控点丈量时，气泡居中或者用三角支撑杆固定，承认好所测像控点方位以及对应点号，不能搞错点号与之对应的坐标。
                            断定并设置对应的仪器天线类型和天线高（像控点高程尤为重要）。
                            最后，一定得先承认所需要像控点坐标的参数，投影、坐标系、中心子午线及带度。
                            哈瓦国际航空技术（深圳）有限公司是一家致力于工业级无人机研发与制造的高新技术企业。
                            哈瓦拥有强大的技术研发团队，在中国深圳与德国不莱梅均设有研发中心。拥有多名高级结构设计师、光电技术工程师、软件工程师等高科技人才，同时结合市场需求特点还不断引进世界先进技术。哈瓦自主研发生产的哈瓦无人机已广泛应用于公安执法、消防救援、地理测绘、电力巡线、水利巡检、石化、工程建设、环保监测等多个领域。包括消防无人机、测绘无人机、警用无人机等`,
                    imgurl:require('../assets/img/new5.jpg')
                },
                {
                    Id:14,
                    Type:2,
                    title:"无人机容易被干扰的原理解析",
                    CreateTime:"2018/10/19 13:41",
                    Content:`设备由手持式主机和电池组组成。手持式主机为三频段发射机天线一体化设计，可以同时产生2.4GHz/5.8GHz频段无人机飞控干扰信号以及卫星定位干扰信号，通过对无人机的上行飞控信道和卫星定位信道进行阻塞式干扰，从而使其失去飞控指令和卫星定位信息，使之无法正常飞行，根据无人机的设计不同会产生返航、降落以及坠落的管控效果。深度解析无人机容易被干扰的原理_宇辰网_让世界读懂无人机_全球专业无人机服务资讯平台在攻防态势上，通常无人机的操纵者和需要设防的敏感区域之间有一定距离。无人机从操纵者附近起飞，然后逐渐飞临设防区域。当无人机到达设防区域附近，能够开展有效的侦查或破坏活动时，无人机到设防区域的距离，通常比它到操纵者的距离要近得多。在上述态势中，操纵者发送的一切上行信号（从地面向无人机发送）都会因为距离远而比较微弱。采用同样的功率，防御者由于距离无人机更近，信号将比操纵者强。防御者收到的下行信号也会比操纵者强。但是对下行信号的防御目标是让操纵者收不到，而此时无人机到操纵者的距离，和防御者到操纵者的距离是差不多的。所以对下行信号的阻断不占地形优势。
                            从上面分析可以看出干扰上行信号更为有利。恰巧上行信号通常是遥控信号，直接关系到对无人机的操控，如果上行信号被干扰，无人机将失去即时控制，只能按照程序预设的步骤运行（通常是降落或者悬停）。而下行信号主要是遥测和图像等，虽然也可能存在敏感信息，但相比控制信号而言就不那么重要了，再加上防御者在态势上不占优势，通常对下行信号采取放任态度。
                            GPS依靠中轨道卫星。通俗而言就是信号经过上万公里到达地球表面，已经非常微弱。所以要在无人机离防御者很近的情况下干扰GPS信号是比较容易的。如果想欺骗它就需要用比较复杂的手段来模拟GPS卫星，会困难得多。
                            目前，对无人机的控制多使用无线电通信技术，通过向目标无人机发射大功率干扰信号，对控制信号进行压制，就可以迫使无人机自行降落或返航。
                            美国就是利用了这个原理。这款枪把一个电子干扰器安装在步枪的框架上，一旦扣动扳机，干扰器会向无人机发射全频段的干扰信号，使无人机脱离操作者的控制，接收不到控制信号而自动降落到地面。
                            一旦无人机的信号处于混乱状态，它通常有3种选择：跌落到地面、返回操作者身边或平稳下降。这种步枪的有效射程达到了500～2000米。
                            目前，在正常情况下绝大多数消费级无人机都会首选GPS导航来进行飞行控制，而民用GPS信号是非加密的，这就留下了可利用的空间。
                            GPS欺骗的主要原理就是向无人机的控制系统发送虚假的地理位置坐标，从而控制导航系统，诱导无人机飞向错误的地点。GPS信号可以由发生器来产生，也可以是事先录制然后重放。由于无人机接收GPS信号总是以信号最强的信号源为准，因此在地面人造的GPS信号只要强度足够大，就可以覆盖真正的从太空中传来的GPS信号，从而欺骗无人机的GPS接收模块。
                            当前，各个国家都在核心区域设置了禁飞区，许多无人机制造厂商在无人机内置固件中进行了设置，在禁飞区内无人机无法起飞，即使到达了禁飞区也会自动降落。因此，只要地面人造的GPS信号将地理位置模拟为禁飞区的坐标，就可以迫使无人机自行降落。
                            现在，无人机使用的控制信号大多在1.2GHz、2.4GHz、5.8GHz等常规民用频段，随着Arduino和树莓派等开源硬件的快速发展和软件无线电（SDR）技术的流行，普通爱好者也可以利用从网络买到的硬件和从论坛获得的软件源码模拟遥控器向无人机发送控制信号，并覆盖真正遥控器的信号，从而获得无人机的控制权。
                            很多无人机为方便用户使用手机和平板电脑等移动设备进行操控，直接使用Wi-Fi进行交互。这样一来，一些在互联网中已经很成熟的黑客技术就可以直接应用在无人机上。
                            例如，通过无人机控制系统中开放的端口或密码猜解等手段，进入控制系统实现对无人机的控制。开发出“萨米蠕虫病毒”的传奇黑客萨米 卡姆卡尔（Samy Kamkar）就利用这个原理编写了一个名为“SkyJack”的无人机劫持软件，并将软件安装到经过特殊配置的无人机中，SkyJack在空中飞行并寻找Wi-Fi范围内的其他无人机，然后入侵该无人机并取得控制权。
                            业内从事反无人机应用的专业人士表示，当前国内的反无人机技术还处在摸索阶段，无线电劫持技术由于各无人机厂家对无线电信号进行了加密处理很难实现，而黑客技术由于门槛较高不易商业化，因此当前所采用的技术主要以干扰阻断为主。`,
                    imgurl:require('../assets/img/new6.jpg')
                },
                 {
                    Id:15,
                    Type:2,
                    title:"飞控相关的地磁知识小结",
                    CreateTime:"2018/10/19 13:41",
                    Content:`1、飞控里面的地磁计的作用?
                        飞控里的传感器单元，最重要的是IMU，这里一般是泛指，准确的说法是AHRS(姿态航向参考系统)，前面有提到过，加速度计和陀螺仪能准确估计出飞行器的roll和pitch，然而yaw是不能通过这两个准确得到的，这里就需要地磁计了。地磁计主要是根据地磁向量，求出飞行器与磁北的夹角。
                        2、地磁计的原始数据?
                        姿态解算算法运行前，飞控驱动层要能准确获取地磁计的数据，然而如何判定数据的有效性呢?
                        根据手册，一般会提供如何配置，并转换成高斯单位。判定数据的方法就是当模块指向真北的时候，x/y轴的数据正向最大，指南的时候，为负值最大。而且一般地球磁场(忽略干扰的话)数值很小，大约只有0.5高斯。
                        3、计算yaw需要加速度计吗?
                        需要用到加速度计校准飞行器的水平误差，补偿倾斜角度。
                        4、磁偏角?
                        姿态解算的时候，如要得到精确的yaw，则需要考虑磁偏角，这是什么?
                        因为基于磁北方向的航向角与真北方向的航向角是有差异的，也就是磁北和真北存在角度偏差，而我们姿态解算是靠磁北来算与真北的角度，所以要补偿这个夹角，这个就是磁偏角，因为地磁是会随着时间、地点变化而变化，所以磁偏角也不是一个固定值。
                        当然，一般这个角度不是很大的值，大约在5度左右，精度要求高的话可以补偿。
                        5、如何计算磁偏角?
                        可以根据GPS得到当前飞行器的经纬度，通过经纬度去计算磁偏角，相应的计算参看开源飞控PX4代码。
                        6、地磁干扰?
                        由于地磁磁场太过微弱，只有0.5高斯，所以很容易受到外界干扰，数据变化较大。
                        一般将地磁干扰分成两种，一种是硬磁干扰，另一种是软磁干扰。
                        硬磁干扰：认为是飞行器上被磁化的物质所产生的，一般干扰是一个固定值，不随着航向的变化而变化;
                        软磁干扰：认为是地磁磁场与飞行器周围的磁化物质相互作用而产生的，这个干扰数值通常不是一个固定值，与航向有关。
                        7、地磁校准?
                        那如何去除干扰?通常是在使用前进行校准。
                        一般方法就是将飞行器按特定角度进行转动，得到不同姿态下的磁场强度值，通过对测量值进行分析来校准，主要用来纠正零偏。
                        8、校准方法的区别?
                        校准地磁的算法，常见的有最小二乘拟合椭球、求取零点偏移等方法。
                        9、不校准的影响?
                        Mag如果不进行校准，而原始数据的零点偏移很大的时候，这时候计算yaw会有很大的误差。
                        10、如何判定是否需要校准?
                        为什么到一个新地方就需要校准?
                        不同的地理环境，会让地磁数据发生变化，即零偏会发生变化，所以一般在新的地理环境下都需要进行校准。
                        a)看mag的原始数据值，旋转一圈，最大最小值得到的零点是否偏离0很大;
                        b)又或者通过yaw进行判定，飞行过程中，飞行器往前飞行(只打pitch杆)，是否飞的很直;c)地面实时看yaw，每次旋转90度，转一圈，看每次yaw的收敛情况和收敛方向，如最终收敛的角度与旋转的90度较大误差，则需要进行校准。
                        11、地磁校准能解决一切问题吗?
                        答案是否定的，在某些极端情况下，地磁的干扰不能完全通过校准进行消除。
                        简单来说，比如外界的干扰造成地磁向量出现偏差，所以这时候通过这个有偏差的地磁向量作为参考去校准，所得到的值也是不正确的，校准只能解决数据偏移问题，不能解决干扰问题。因此会造成yaw不够精确，保证飞行的直线，这个要求在植保机尤为重要。出现这种情况下，只能通过其他办法进行补偿，比如加入GPS数据，这里笔者提供一个思路，前飞时，获取gps的heading_2d信息，即飞行器前进的角度，如果不是直线飞行，yaw有误差，则两者之间会有误差，将该误差进入解算中进行补偿，可得到较为准确的yaw(注：该方法只适用于飞行速度较快的情况下)。`,
                    imgurl:require('../assets/img/new7.jpg')
                },
                {
                    Id:16,
                    Type:2,
                    title:"航测无人机要注意什么",
                    CreateTime:"2018/10/18 16:37",
                    Content:`航测无人机作为无人机大家族中专业性很强的一个分支，因为其造价之贵，人员之专业，飞控要求之高，后处理软件之复杂，往往让很多想入手的朋友望而却步。
                            但是无人机航测相对于人工测来说，优势可不简简单单是效率的问题，而是一个市场导向的问题，更早地进入航测市场，就能获取宝贵的航测经验，意味着更广阔的业务承接面，在传统测绘市场变化的今天，及时接触航测，能打开测绘行业的另一扇大门。
                            那么在选购航测无人机时有哪些要注意事项呢？
                            无人机哪些地方不能飞？
                            1.机场
                            2.北京六环以内
                            3.高压电线等高架设施
                            4.军事及国家机关敏感区域
                            5.高层建筑以及人群聚集的地方
                            注：如果测区附近有以上敏感区域，就请先咨询无人机厂家，确定所在位置不是禁飞区后，方可操作无人机，如果是禁飞区，可以去向飞行管制部门提出申请，经批准后方可实施。
                            我该选择多旋翼飞机还是固定翼飞机？
                            答：选择什么样的无人机，主要看摄区范围与用途。
                            1.多旋翼的优点：轻便，造价相对低廉，可以定点悬停
                            适合方向：航拍，环境监测，侦查，特殊物体运输等小区域应用
                            2.固定翼的优点：续航时间长，抗风性能好，拍摄幅面广
                            适合方向：航测、区域监控、管道巡线、抢险救灾、应急通信等大区域应用
                            做航测要几个人，要经过多久的培训能够完成项目？
                            答：完成外业航飞需要2个人，地面站与飞控手各需一人即可。现在随着飞控系统越来越完善，单兵作业也不再遥远了，内业人数可根据具体项目要求配备。
                            无人机航测系统，外业航飞培训时间一般为3天;后处理软件需要看最后出什么类型的成果，培训时间就是有所不同，现在常用的一般空三使用inpho，立测使用MapMatrix，DOM制作用EPT。
                            精度能不能达到要求?
                            答：一般航测无人机，可以满足1：1000、1：2000的分辨率的DOM/DLG航拍要求，在平原地区可以满足1:500分辨率的航拍要求。但是精度还受到相机与后处理等多种因素的制约。一般存在的是1:500的高程精度，控制不好。
                            无人机航测有哪些步骤？
                            答：首先确定飞行区域与成图要求、做好相控点，然后就可以根据测区要求在地面站里编辑航线，选择合适的气象条件(天气、光照、风力、云层高度、空气可见度)到达现场进行航拍。`,
                    imgurl:require('../assets/img/new8.jpg')
                },
                {
                    Id:9,
                    Type:2,
                    title:"GPS坐标系转换原理",
                    CreateTime:"2018/07/02 10:51",
                    Content:`对坐标转换原理的理解有助于用户更好的掌握工程之星软件的校正步骤。GPS接收机的一个显著特点就是GPS接收机的OEM板输出的坐标是GPS的WGS84椭球下的经纬度坐标，而通过软件输送给GPS接收机的坐标也只能是GPS的WGS84椭球下的经纬度坐标，否则GPS接收机的工作就会出错。因此GPS系统显示的坐标都首先要通过相应的软件把GPS主板输出的坐标转化到当地施工坐标。这一点在本书前面某些章节的内容中已经介绍。软件在实现WGS84的经纬度坐标转化成施工平面坐标时一般都经过下表所示的流程：
                        　　以上的坐标转换流程都是可逆的。也就是说RTK系统的基准站正常工作时发射的都是WGS84的经纬度，移动站依据基准站的WGS84的经纬度坐标得到相应的固定解状态下的WGS84的经纬度，再经上述流程图的转换后由控制器把施工坐标显示出来。
                        　　由此可知，每一次基准站的启动都必须获取一个当前基准站所架设点位的WGS84经纬度坐标后才能正常的发射，而转换参数的计算也必须使用WGS84坐标，因此WGS84坐标的获取在这里就显得至关重要了。
                        WGS84坐标的获取有两种方式：
                        　　一种是由基准站直接读取当前测出的经纬度坐标（GPS坐标每一秒刷新一次，每一次读取的坐标都有差异，误差在1至2米之间）；
                        　　一种是事先布设好静态控制网，从静态处理结果中获取。由于WGS84经纬度获取的相对不确定性使得在求解转换参数时必须首先确定一组公共控制点的WGS84经纬度坐标，这组坐标一旦确定以后每次启动基准站时都要使用这一组WGS84经纬度坐标，否则使用转换参数时的显示坐标和实际施工坐标间就会存在一个固定偏差，这个偏差是由所取的基准站WGS84经纬度坐标和用来计算转换参数的WGS84经纬度坐标之间的差异产生的。 
                        　　需要特别说明的是：南方的RTK自动启动基准站时取的坐标是基准站开机并达到状态(即PDOP<3)以后自动取的WGS84经纬度坐标，这样就会出现上述所描述的固定偏差，工程之星软件通过一个公共已知点求出的转换参数(工程之星软件中把这个过程称为“校正”，参数称为“校正参数”)来克服这个固定偏差，因此工程之星软件中有一个区别于其他软件的校正参数的概念。
                        　　南方工程之星及其它的手薄采集软件中，系统会根据用户使用点的个数自动计算出相应的参数，详情请查看《南方RTK参数的求取及分类》`,
                    imgurl:require('../assets/img/new9.jpg')
                },
            ]
        }
    },
    components:{
        Banner
    },
}
</script>
<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.news{
    width: 100%;
    height: 100%;
    background-color: #14679f;
    position: relative;
    overflow: hidden;

    &-section{
        width: 100%;
        
        &-content{
            width: 90%;
            // height: 1600px;
            margin: 0 auto;
            background-color: #fff;
            border: 1px solid #15669E;
            border-radius:10px ;

            .content-nav{
                width: 35%;
                height: 55px;
                border: 1px solid #15669E;
                border-radius:10px ;
                margin: 0 auto;
                display: flex;
                align-items: center;
                position: relative;
                bottom: 30px;

                &-btn{
                    width: 50%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #fff;
                    border-radius:10px ;
                }

                .content-nav-active{
                    background-color:#15669E;
                    color: #fff;
                }
            }

            .content-nav-item{
                width: 90%;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                flex-wrap:wrap ;

                .item-list{
                    width: 20%;
                    height: 400px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    margin: 10px 10px;
                    border: 1px solid #15669e;

                    &:hover{
                        border: 1px solid #fff;
                        box-shadow: 0 0 5px 2px #bfd3e0;
                    }
                    .item-img{
                        width: 90%;
                        background-repeat: no-repeat;
                        background-size: cover;
                        background-position: center;
                        background-origin: content-box;
                    }
                    &-title{
                        // width: 80%;
                        height: 30px;
                        color: #15669e;
                        font-size: 18px;
                        padding: 0 10px;
                        margin: 20px 0;
                        text-align: center;
                    }
                    &-content{
                        width: 80%;
                        font-size: 10px;
                        color: gray;
                        text-indent: 24px;

                        //文本长度处理  s
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 5;
                        -webkit-box-orient: vertical;
                        white-space: normal !important;
                        word-wrap: break-word;
                        //文本长度处理  e
                    }
                    &-more{
                        width: 80%;
                        margin-top: 10px;
                        margin-bottom: 10px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;

                        img{
                            width: 12px;
                            height: 12px;
                        }
                        span{
                            color:red;
                            padding: 0 5px;
                        }
                    }
                }
            }
        }
    }
}
</style>